@if (product.length! <= 0 && !notProduct) {
  <div class="loadContainer p-5">
    <fa-icon [icon]="iconSpinner" size="4x" animation="spin" [style]="{ color: 'white' }"></fa-icon>
  </div>
}
@if (notProduct) {
  <!-- <p class="notProduct">404 <br><span> Not Found</span></p> -->
  <img src="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/404_not_found_fun.webp" class="img_notProduct" />
}
@for (item of product; track $index) {
  <div
    class="container__product"
    [class.container__product__sofubi]="item.typeToys === 2"
    [class.container__product__blindbox]="item.typeToys === 4"
    [class.container__product__artoys]="item.typeToys === 1"
    [class.container__product__gachapon]="item.typeToys === 3"
  >
    <div class="bg_black"></div>
    <div class="grid_2_column none text-center">
      @if (product) {
        @switch (item.typeToys) {
          @case (1) {
            <div class="tag">
              <a [routerLink]="['/category', 'artoys']" class="category_link"> Art Toys </a>
            </div>
          }
          @case (2) {
            <div class="tag">
              <a [routerLink]="['/category', 'sofubi']" class="category_link"> Sofubi </a>
            </div>
          }
          @case (3) {
            <div class="tag">
              <a [routerLink]="['/category', 'gachapon']" class="category_link"> Gachapon </a>
            </div>
          }
          @case (4) {
            <div class="tag">
              <a [routerLink]="['/category', 'blindbox']" class="category_link"> BlindBox </a>
            </div>
          }
        }
      }

      <img [src]="imgPrimary.img" class="imgPrimary" [alt]="imgPrimary.alt" />
    </div>
    <div class="grid_2_column">
      <h1>{{ item.name }}</h1>
      @if (item.ranffle) {
        @for (cu of item.price_currency; track $index) {
          @if (cu.currency === currency) {
            <p class="mb-2 h5">{{ cu.regular_price | currency }} {{ cu.currency }}</p>
          }
        }
        <app-carousel [item]="item.images" />
        <app-ranffle [item]="item" />

        <!-- <ul class="list-inline">
        @for (img of item.images; track $index; let i = $index) {
        @if (i >= 1) {
        @if (img.size === 1000) {
        <li class="list-inline-item mb-3">
          <img [src]="img.src" [alt]="img.alt" (click)="opemViewImg(img.src)" />
        </li>
        }
        }
        }
      </ul> -->
      } @else {
        @for (cu of item.price_currency; track $index) {
          @if (cu.currency === currency) {
            @if (cu.sale_price) {
              <p class="mb-2 h5 sale">{{ cu.regular_price | currency }} {{ cu.currency }}</p>
              <p class="mb-2 h5 ofert">{{ cu.sale_price | currency }} {{ cu.currency }}</p>
            } @else {
              <p class="mb-2 h5">{{ cu.regular_price | currency }} {{ cu.currency }}</p>
            }
          }
          @if (cu.currency === "USD") {
            <p>The price is an approximate, the cost of the figure will be charged in the store's local currency</p>
          }
          <ul class="list-inline">
            @for (img of item.images; track $index; let i = $index) {
              @if (i >= 1) {
                @if (img.size === 1000) {
                  <li class="list-inline-item mb-3">
                    <img [src]="img.src" [alt]="img.alt" (click)="opemViewImg(img.src)" />
                  </li>
                }
              }
            }
          </ul>
          <div class="details" [innerHTML]="item.descriptions | details"></div>
          <!-- <p>¿Quieres estar siempre al día con nuestras últimas ofertas y productos?</p>
          <p>Te invitamos a unirte a nuestros canales de Telegram y WhatsApp. Allí recibirás atención personalizada y actualizaciones exclusivas sobre nuestros productos.</p>
          <ul class="sendpulse">
            <li>
              <p>
                <a href="https://etoyrepublicbot.tg.pulse.is/" target="_blank">
                  <fa-icon [icon]="iconTL"></fa-icon>
                  Telegram</a
                >
              </p>
            </li>
            <li>
              <p>
                <a href="https://5215565759219.wa.pulse.is/" target="_blank">
                  <fa-icon [icon]="iconWA"></fa-icon>
                  Whatsapp</a
                >
              </p>
            </li>
          </ul> -->
        }
        @if (item.stock >= 1 && item.store !== true) {
          @if (!activeShop) {
            @if (item.date_sale) {
              @if (saleDone) {
                @if (item.stock >= 1 && !activeShop) {
                  <div class="quantity" [formGroup]="formQty">
                    <input type="number" name="tentacles" min="1" [max]="item.stock" step="1" value="1" formControlName="qty" aria-label="qty" />
                  </div>
                } @else {
                  <p>Si deseas cambiar la cantidad de productos, vuelve a cargar el sitio.</p>
                }
                <button (click)="shopProduct()" class="btn btn__default btn__block mb-4" gaEvent="button_init_shop" i18n>Comprar</button>
              } @else {
                <h3 class="text-center">
                  <b>Este producto estara a la venta el dia {{ dateActiveShop | date: "dd/MM/yyyyhh:mm" }}</b>
                </h3>
                <!-- else saleDone -->
              }
            } @else {
              @if (item.stock >= 1 && !activeShop) {
                <div class="quantity d-inline-block me-3" [formGroup]="formQty">
                  <input type="number" name="tentacles" min="1" [max]="item.stock" step="1" value="1" formControlName="qty" aria-label="qty" />
                </div>
                <!--<p>Hemos deshabilitado temporalmente el botón de compra porque estamos en Clandestino y actualizando nuestro
                          stock. ¡Gracias por tu paciencia! Pronto estaremos de vuelta con más productos disponibles. </p>
                          <p>Si deseas un producto mandanos mensaje en nuestros canales de comunicación para darte la atención personalizada.</p>-->
                <app-button-add-items [item]="item" [qty]="formQty.value" [max]="item.stock" />
                <app-reques-stripe-button [item]="item"></app-reques-stripe-button>
              } @else {
                <p>Si deseas cambiar la cantidad de productos, vuelve a cargar el sitio.</p>
              }
            }
          }

          @if (activeShop) {
            <div class="container__payment mb-4">
              <app-stripe [tags]="id" [price_product]="(item?.price_currency)![0].regular_price" [qtyProduct]="qty()" />
            </div>
          }
        } @else {
          @if (item.store === true) {
            <p>Este producto solo se compra en la Drop Store ya sea en tienda fisica o por IG</p>
          }
          <button class="btn btn__not-available btn__block mb-4" i18n>Agotado</button>
        }
      }
      <!-- <app-reques-stripe-button [item]="item" /> -->
      <div class="text-center mb-5 pb-5 mt-5">
        <ul class="list-inline">
          <li class="list-inline-item" (click)="termModal()">Términos y Condiciones -</li>
          <li class="list-inline-item" (click)="devoModal()">Política de Devolución y Reembolso</li>
        </ul>
      </div>
      <!-- end grid -->
    </div>
  </div>
}
